// Promise-based modal helper — usa CSS variables (theme-aware).
//
// `body` se inserta como TEXTO por defecto: los mensajes suelen incluir datos
// escritos por el usuario (nombres de premios, misiones, héroes) y meterlos
// por innerHTML era un XSS almacenado. Para HTML deliberado, pasar un Element
// ya construido o `html: true`.

let idSeq = 0;

export function showModal({ title, body, actions = [], dismissible = true, html = false }) {
  return new Promise((resolve) => {
    const uid = `modal-${++idSeq}`;
    const prevFocus = document.activeElement;

    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay';

    const card = document.createElement('div');
    card.className = 'modal-card';
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-modal', 'true');

    if (title) {
      const h = document.createElement('h3');
      h.className = 'modal-title';
      h.id = `${uid}-title`;
      h.textContent = title;
      card.appendChild(h);
      card.setAttribute('aria-labelledby', h.id);
    }
    if (body) {
      const b = typeof body === 'string' ? document.createElement('div') : body;
      if (typeof body === 'string') {
        if (html) b.innerHTML = body; else b.textContent = body;
      }
      b.className = (b.className ? b.className + ' ' : '') + 'modal-body';
      b.id = `${uid}-body`;
      card.appendChild(b);
      card.setAttribute('aria-describedby', b.id);
    }

    const close = (value) => {
      document.removeEventListener('keydown', onKey);
      overlay.remove();
      if (prevFocus && typeof prevFocus.focus === 'function') prevFocus.focus();
      resolve(value);
    };

    function onKey(e) {
      if (e.key === 'Escape' && dismissible) { e.preventDefault(); close(null); return; }
      if (e.key !== 'Tab') return;
      // Focus trap: el tabulador no debe escapar del diálogo.
      const focusables = card.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    const row = document.createElement('div');
    row.className = 'modal-actions';
    for (const a of actions) {
      const btn = document.createElement('button');
      btn.textContent = a.label;
      btn.className = `btn ${a.variant === 'primary' ? 'btn-primary' : 'btn-ghost'}`;
      btn.onclick = () => close(a.value);
      row.appendChild(btn);
    }
    card.appendChild(row);
    overlay.appendChild(card);

    if (dismissible) {
      overlay.onclick = (e) => { if (e.target === overlay) close(null); };
    }

    document.body.appendChild(overlay);
    document.addEventListener('keydown', onKey);
    // Foco inicial en la acción principal (o la primera disponible).
    const primary = row.querySelector('.btn-primary') || row.querySelector('button');
    primary?.focus();
  });
}

export const confirm = (msg, title = 'Confirmar') => showModal({
  title,
  body: msg,
  actions: [
    { label: 'Cancelar', value: false },
    { label: 'Confirmar', value: true, variant: 'primary' },
  ],
});

export const alert = (msg, title = 'Aviso') => showModal({
  title,
  body: msg,
  actions: [{ label: 'OK', value: true, variant: 'primary' }],
});

if (typeof window !== 'undefined') {
  window.appConfirm = confirm;
  window.appAlert = alert;
}
